import { ReactNode } from "react";
import { cn } from "@/lib/utils";

// Overview/detail page section: small bold title + optional right-aligned
// action, with protocol spacing. See DESIGN.md "Section".
export const Section = ({
  title,
  action,
  children,
  className,
}: {
  title: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}) => (
  <section className={cn("space-y-2", className)}>
    <div className="flex items-center justify-between gap-2">
      <h2 className="text-sm font-semibold text-foreground">{title}</h2>
      {action}
    </div>
    {children}
  </section>
);

export default Section;
